/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Strength_TargetInputs */

const en_portal_goal_strength_target = /** @type {(inputs: Portal_Goal_Strength_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A squat record in 12 weeks`)
};

const pl_portal_goal_strength_target = /** @type {(inputs: Portal_Goal_Strength_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekord w przysiadzie za 12 tygodni`)
};

/**
* | output |
* | --- |
* | "A squat record in 12 weeks" |
*
* @param {Portal_Goal_Strength_TargetInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_strength_target = /** @type {((inputs?: Portal_Goal_Strength_TargetInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Strength_TargetInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_strength_target(inputs)
	return en_portal_goal_strength_target(inputs)
});